// extracted by mini-css-extract-plugin
module.exports = {"iconImage":"Footer_iconImage__zA0yR"};